import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { Subscription } from 'rxjs/Subscription';

import { FormHelper } from '../../helpers/form-helper';
import { Application } from '../../models/application';
import { Meetup } from '../../models/meetup';
import { ApplicationService } from '../../services/application.service';
import { MeetupService } from '../../services/meetup.service';

@Component({
  selector: 'app-forward-application',
  templateUrl: './forward-application.component.html',
  styleUrls: ['./forward-application.component.scss']
})
export class ForwardApplicationComponent extends FormHelper implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;
	public meetups: Observable<Meetup[]>;
	private application: Application;

  constructor(private dialogRef: MdDialogRef<ForwardApplicationComponent>,
							private formBuilder: FormBuilder,
							private applicationService: ApplicationService,
							private meetupService: MeetupService) {
		super();
		this.subscriptionManager = new Subscription();

		this.buildForm();

		this.meetups = meetupService.getNextMeetups();
	}

  ngOnInit() {
	}

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public buildForm(): void {
		this.form = this.formBuilder.group({
			meetup: new FormControl('', Validators.required)
		});
	}

	public updateForm(application: Application): void {
		this.application = application;
	}

	public submitForm(): void {
		let application: Application = this.form.value;
		if (application.meetup !== undefined) {
			this.subscriptionManager.add(this.meetups.map(ms => ms.filter(m => m.$key === application.meetup)[0]).subscribe(next => {
				this.application.meetup = application.meetup;
				this.application.meetupDescription = next.description;

				this.applicationService.updateApplication(this.application.$key, this.application);

				this.dialogRef.close();
			}));
		}
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/forward-application/forward-application.component.ts